import type { UserType } from "../types";

export type RateLimitPresetKey =
  | "chat"
  | "conversation"
  | "vehicle"
  | "grounding"
  | "multimodal:image"
  | "multimodal:audio"
  | "multimodal:video"
  | "refinePrice"
  | "masterMode"
  | "sanayiRaporu:session"
  | "sanayiRaporu:bilgiToplama"
  | "sanayiRaporu:ozet"
  | "sanayiRaporu:raporOlustur"
  | "sanayiRaporu:ustaArama"
  | "sanayiRaporu:media:image"
  | "sanayiRaporu:media:audio"
  | "sanayiRaporu:media:video";

type TierLimits = Record<UserType, string>;

interface RateLimitPreset {
  label: string;
  limits: TierLimits;
}

const tierLimits = (
  anonymous: string,
  registered: string,
  premium: string
): TierLimits => ({
  anonymous,
  registered,
  premium,
});

export const RATE_LIMIT_PRESETS: Record<RateLimitPresetKey, RateLimitPreset> = {
  chat: {
    label: "Chat mesajı",
    limits: tierLimits("3/gün", "100/gün", "500/gün"),
  },
  conversation: {
    label: "Aktif Sohbet",
    limits: tierLimits("1 toplam", "3 toplam", "10 toplam"),
  },
  vehicle: {
    label: "Kayıtlı Araç",
    limits: tierLimits("1 toplam", "5 toplam", "20 toplam"),
  },
  grounding: {
    label: "Detaylı Araştırma",
    limits: tierLimits("0/gün", "5/gün", "100/gün"),
  },
  "multimodal:image": {
    label: "Görsel analizi",
    limits: tierLimits("1/gün", "10/gün", "50/gün"),
  },
  "multimodal:audio": {
    label: "Ses analizi",
    limits: tierLimits("0/gün", "5/gün", "30/gün"),
  },
  "multimodal:video": {
    label: "Video analizi",
    limits: tierLimits("0/gün", "3/gün", "20/gün"),
  },
  refinePrice: {
    label: "Fiyat netleştirme",
    limits: tierLimits("0/gün", "5/gün", "50/gün"),
  },
  masterMode: {
    label: "Usta Modu",
    limits: tierLimits("Kapalı", "Kapalı", "Sınırsız"), // Premium exclusive
  },
  // Sanayi Raporu
  "sanayiRaporu:session": {
    label: "Aktif rapor oturumu",
    limits: tierLimits("0 toplam", "3 toplam", "10 toplam"),
  },
  "sanayiRaporu:bilgiToplama": {
    label: "Rapor bilgi toplama",
    limits: tierLimits("0/gün", "30/gün", "200/gün"),
  },
  "sanayiRaporu:ozet": {
    label: "Rapor özet",
    limits: tierLimits("0/gün", "5/gün", "30/gün"),
  },
  "sanayiRaporu:raporOlustur": {
    label: "Rapor oluşturma",
    limits: tierLimits("0/gün", "3/gün", "15/gün"),
  },
  "sanayiRaporu:ustaArama": {
    label: "Rapor usta arama",
    limits: tierLimits("0/gün", "3/gün", "15/gün"),
  },
  "sanayiRaporu:media:image": {
    label: "Rapor görsel analizi",
    limits: tierLimits("0/gün", "5/gün", "30/gün"),
  },
  "sanayiRaporu:media:audio": {
    label: "Rapor ses analizi",
    limits: tierLimits("0/gün", "3/gün", "20/gün"),
  },
  "sanayiRaporu:media:video": {
    label: "Rapor video analizi",
    limits: tierLimits("0/gün", "2/gün", "10/gün"),
  },
};
